import { Theme } from '@mui/material'
import { grey } from '@mui/material/colors'

const useStyles = {
  addressIcon: {
    color: grey[500],
  },
  selectedAddressIcon: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  foldersAddress: (theme: Theme) => ({
    border: `1px solid ${grey[300]}`,
    borderRadius: '8px',
    padding: theme.spacing(2, 0, 2, 1),
    width: '100%',
    margin: theme.spacing(1, 0),
  }),
  selectedFolderAddress: (theme: Theme) => ({
    border: `1px solid ${theme.palette.primary.main}`,
  }),
  folderName: {
    fontWeight: 'bold',
  },
}

export default useStyles
